// eslint-disable-next-line import/prefer-default-export
export const SET_WALLET_ADDRESS = "SET_WALLET_ADDRESS";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_PROFILE_MODAL_STATUS = "SET_USER_PROFILE_MODAL_STATUS";


